import React from "react";
import { useTranslation } from "react-i18next";
import "./style.min.css";
import { CALENDLY_URL } from "../../constants/links";
import { trackSeoEvent } from "../../helpers/analytics";
// import photoImene from "../../assets/images/imeneYahiaoui.png";
import photoImene2 from "../../assets/images/imene yahiaoui photo.webp";
// import InstallButton from "../../components/InstallButton";
const Hero = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <section
      dir={isRTL ? "rtl" : "ltr"}
      className="mt-6 hero-theme relative overflow-hidden backgroundIssu px-6 py-20 lg:px-12 xl:px-20 text-[var(--color_text)]"
    >
      {/* Background effects */}
      <div className="pointer-events-none absolute inset-0">
        <div className="hero-blob hero-blob-one" />
        <div className="hero-blob hero-blob-two" />
        <div className="hero-grid absolute inset-0" />
      </div>

      <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-2">
        {/* TEXT SIDE */}
        <div
          className={`${isRTL ? "lg:order-2 text-right" : "lg:order-1 text-left"}`}
        >
          <span
            className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold shadow-sm backdrop-blur-xl"
            style={{
              background:
                "color-mix(in srgb, var(--background_box) 78%, transparent)",
              borderColor:
                "color-mix(in srgb, var(--primary) 18%, transparent)",
              color: "var(--primary)",
              boxShadow: "var(--btn-shadow)",
            }}
          >
            <span className="h-2.5 w-2.5 rounded-full bg-[var(--primary)] animate-pulse" />
            {t("hero.hero_tagline") || "Sites web & SaaS sur mesure"}
          </span>

          <h1 className="mt-6 max-w-full text-4xl font-black leading-[1.05] sm:text-5xl md:text-[2rem] xl:text-[3rem]">
            <span className="relative inline-block text-[var(--primary)]  ">
              {t("hero.hero_title")}
            </span>

            <span className="mt-3 block text-[var(--primary)]">
              {t("hero.hero_highlight") || "React & Angular"}
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-[var(--body_color)] md:text-xl">
            {t("hero.hero_subtitle")}
          </p>

          <div
            className={`mt-10 flex flex-wrap gap-4 ${
              isRTL ? "justify-end" : "justify-start"
            }`}
          >
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackSeoEvent("booking_click", { label: "hero" })}
              className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold text-white shadow-lg transition duration-300 hover:-translate-y-1 sm:text-lg"
              style={{
                background: "var(--hover)",
                boxShadow: "var(--btn-shadow)",
              }}
            >
              {t("hero.cta_call")}
            </a>

            <a
              href="/quote"
              className="inline-flex items-center justify-center rounded-2xl border px-6 py-3 text-base font-semibold transition duration-300 hover:-translate-y-1 sm:text-lg"
              style={{
                borderColor: "var(--primary)",
                color: "var(--primary)",
                background:
                  "color-mix(in srgb, var(--background_box) 85%, transparent)",
                boxShadow: "var(--btn-shadow)",
              }}
            >
              {t("hero.cta_quote")}
            </a>
          </div>
          {/* <div
            className="mt-10 inline-flex rounded-[24px] p-2"
            style={{
              background:
                "color-mix(in srgb, var(--background_soft) 86%, white 14%)",
              boxShadow: "var(--box-shadow)",
            }}
          >
            <InstallButton />
          </div> */}
          {/* mini cards */}
          <div
            className={`mt-10 flex flex-wrap gap-4 ${
              isRTL ? "justify-end" : "justify-start"
            }`}
          >
            {[
              {
                title: t("hero.card_seo_title"),
                text: t("hero.card_seo_text"),
              },
              {
                title: t("hero.card_react_title"),
                text: t("hero.card_react_text"),
              },
              {
                title: t("hero.card_angular_title"),
                text: t("hero.card_angular_text"),
              },
            ].map((item) => (
              <div
                key={item.title}
                className="min-w-[170px] rounded-2xl border p-4 backdrop-blur-xl transition duration-300 hover:-translate-y-1"
                style={{
                  background:
                    "color-mix(in srgb, var(--background_box) 76%, transparent)",
                  borderColor:
                    "color-mix(in srgb, var(--primary) 14%, transparent)",
                  boxShadow: "var(--btn-shadow)",
                }}
              >
                <span className="block text-base font-extrabold text-[var(--primary)]">
                  {item.title}
                </span>
                <span className="mt-1 block text-sm text-[var(--body_color)]">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* IMAGE SIDE */}
        <div className={`${isRTL ? "lg:order-1" : "lg:order-2"} relative`}>
          <div className="relative mx-auto max-w-[560px]">
            {/* decorative rings */}
            <div
              className="absolute inset-[-18px] rounded-[2rem] border border-dashed opacity-60"
              style={{
                borderColor:
                  "color-mix(in srgb, var(--primary) 30%, transparent)",
              }}
            />
            <div
              className="absolute inset-[16px] rounded-[2rem] border border-dashed opacity-40"
              style={{
                borderColor:
                  "color-mix(in srgb, var(--accent) 30%, transparent)",
              }}
            />

            {/* floating badges */}
            <div
              className={`absolute top-10 z-20 hidden rounded-2xl border px-4 py-3 shadow-xl backdrop-blur-xl sm:block ${
                isRTL ? "right-[-12px]" : "left-[-12px]"
              }`}
              style={{
                background:
                  "color-mix(in srgb, var(--background_box) 78%, transparent)",
                borderColor:
                  "color-mix(in srgb, var(--primary) 15%, transparent)",
                boxShadow: "var(--btn-shadow)",
              }}
            >
              <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-[var(--primary)]">
                {t("footer.services_title") || "Expertise"}
              </p>
              <p className="mt-1 text-sm font-bold text-[var(--color_text)]">
                 React • Angular • Node.js • NestJS
              </p>
            </div>

            {/* <div
              className={`absolute bottom-8 z-20 hidden rounded-2xl border px-4 py-3 shadow-xl backdrop-blur-xl sm:block ${
                isRTL ? "left-[-12px]" : "right-[-12px]"
              }`}
              style={{
                background:
                  "color-mix(in srgb, var(--background_box) 78%, transparent)",
                borderColor:
                  "color-mix(in srgb, var(--primary) 15%, transparent)",
                boxShadow: "var(--btn-shadow)",
              }}
            >
              <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-[var(--primary)]">
                Focus
              </p>
              <p className="mt-1 text-sm font-bold text-[var(--color_text)]">
                Angular • Performance
              </p>
            </div> */}

            {/* image card */}
            <div
              className="relative rounded-[2rem] border p-3 backdrop-blur-xl"
              style={{
                background:
                  "color-mix(in srgb, var(--background_box) 82%, transparent)",
                borderColor:
                  "color-mix(in srgb, var(--primary) 12%, transparent)",
                boxShadow: "var(--box-shadow)",
              }}
            >
              <div className="absolute inset-0 rounded-[2rem] opacity-70 hero-card-glow" />

              <div className="relative overflow-hidden rounded-[1.6rem]">
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(135deg, color-mix(in srgb, var(--secondary) 32%, white), color-mix(in srgb, var(--accent) 18%, white), color-mix(in srgb, var(--highlight) 38%, white))",
                  }}
                />

                <img
                  src={photoImene2}
                  alt={t("photo_alt")}
                  width="560"
                  height="620"
                  fetchPriority="high"
                  className="relative z-10 h-[400px] w-full object-cover sm:h-[500px] lg:h-[620px]"
                />
                <div className="absolute inset-0 z-20 bg-[linear-gradient(to_top,rgba(0,0,0,0.50),transparent_42%)]" />

                <div
                  className="absolute bottom-5 left-5 right-5 z-30 hidden rounded-2xl border p-4 backdrop-blur-xl sm:block"
                  style={{
                    background:
                      "color-mix(in srgb, var(--background_box) 20%, transparent)",
                    borderColor: "rgba(255,255,255,0.18)",
                  }}
                >
                  <p className="text-xs uppercase tracking-[0.22em] text-white/75">
                    {t("hero.hero_tagline")}
                  </p>
                  <p className="mt-2 text-lg font-semibold text-white">
                    {t("description_info.about_title")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
